import { round } from 'lodash';

export const calcLeaderboardScore = (time: number, profit: number, emissions: number) => {
  const timeScore = Math.max((600000 - time) / 600000, 0); // Time in Miliseconds
  const profitScore = Math.max(Math.min(profit / 3000, 1), 0);
  const emissionsScore = Math.max((10 - emissions) / 10, 0);

  return round(100 * timeScore * profitScore * emissionsScore);
};
